import React, { useState } from 'react';
import Box from "@material-ui/core/Box";
import { Grid } from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import { connect, useStore } from "react-redux";
import { Store } from "redux";
import { ApplicationState } from "../../redux/reducers";
import {
    LocationOnOutlined,
    BusinessCenterOutlined,
    VerifiedUserOutlined,
    LocalAtmOutlined,
    CheckCircleOutlined,
    EditOutlined
} from '@material-ui/icons';
import {
    IGuiaWizard,
    navegarSeccionGuiaWizard,
    seccionAlcanzadaActual
} from "../../entities/guias/IGuiaWizard";
import { setGuiaWizard } from "../../redux/actions/guiaActions";
import ConfirmDialog from '../controls/ConfirmDialog';
import { traducirLabel, traducirMessage } from '../../blocks/traductor';

export interface IStepGuia {
    id: number;
    nombre: string;
    esUltimoPaso?: boolean;
    editable?: boolean;
}

interface StateProps {
    guiaWizard: IGuiaWizard;
}

interface DispatchProps {
    setGuiaWizard: typeof setGuiaWizard;
}

type Props = IStepGuia & StateProps & DispatchProps;

const iconoPorPaso: { [id: number]: JSX.Element } = {
    1: <LocationOnOutlined />,
    2: <BusinessCenterOutlined />,
    3: <VerifiedUserOutlined />,
    4: <LocalAtmOutlined />,
    5: <CheckCircleOutlined />
};

const StepGuia = ({
    id,
    nombre,
    esUltimoPaso = false,
    editable = false,
    guiaWizard,
    setGuiaWizard
}: Props) => {
    const store = useStore() as Store<ApplicationState>;
    const [showConfirmDialog, setConfirmDialog] = useState(false);

    const activo = id === guiaWizard.seccionId;
    const alcanzada = seccionAlcanzadaActual(guiaWizard);
    const completado = !activo && alcanzada >= id;
    const estilos = activo ? "active" : completado ? "completed" : "pending";

    const mostrarEditar = (): boolean => {
        if (guiaWizard.createResult) {
            return false;
        }
        return editable && !activo && alcanzada >= id;
    };

    const cambiarSeccion = () => {
        if (guiaWizard.createResult) {
            return;
        }
        setConfirmDialog(true);
    };

    const handleConfirmar = () => {
        if (guiaWizard.createResult && id !== 5) {
            setConfirmDialog(false);
            return;
        }
        const wizardActual = store.getState().guiaWizard;
        setGuiaWizard(navegarSeccionGuiaWizard(wizardActual, id));
        setConfirmDialog(false);
    };

    const handleClose = () => {
        setConfirmDialog(false);
    };

    return (<>
        <Box display="flex" flexDirection="column" alignItems="center" className={estilos}>
            {completado &&
                <Box display="flex" justifyContent="center" alignItems="center" className="complete">
                    <CheckCircleOutlined />
                </Box>
            }
            <Box display="flex" justifyContent="center" alignItems="center" className="oval">
                {iconoPorPaso[id]}
            </Box>
            <Box className="step-label" style={{ position: "relative" }}>
                <span style={{
                    position: "absolute",
                    width: mostrarEditar() ? "140px" : "120px",
                    textAlign: "center",
                    left: "-60px"
                }}>
                    {nombre}
                    {mostrarEditar() &&
                        <IconButton size="small" onClick={cambiarSeccion}>
                            <EditOutlined style={{ fontSize: 15 }} />
                        </IconButton>
                    }
                </span>
            </Box>
        </Box>
        {!esUltimoPaso &&
            <Grid item xs={1} className="step-container" style={{ maxWidth: "6%" }}>
                <div className="circle" />
                <div className="circle" />
            </Grid>
        }
        {showConfirmDialog &&
            <ConfirmDialog
                titulo={traducirLabel(333)}
                contenido={traducirMessage(23)}
                abierto={showConfirmDialog}
                confirmar={handleConfirmar}
                cerrar={handleClose}
            />
        }
    </>);
};

const mapStateToProps = (state: ApplicationState) => ({
    guiaWizard: state.guiaWizard
});

const mapDispatchToProps = {
    setGuiaWizard
};

export default connect(mapStateToProps, mapDispatchToProps)(StepGuia);
